import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const ViewForm = ({ changeRequest, hasApiStatus, callback, history, setPagination }) => {
  const handleSubmit = (fields) => {
    Object.keys(fields).forEach((key) => fields[key] === null && delete fields[key]);

    changeRequest({
      ...fields,
      startDate: fields?.startDate?.replace(/(\d\d)\/(\d\d)\/(\d{4})/, '$3-$1-$2'),
      endDate: fields?.endDate?.replace(/(\d\d)\/(\d\d)\/(\d{4})/, '$3-$1-$2'),
    });
    setPagination(true);
  };

  return (
    <>
      <Form
        type="server"
        direction="row"
        initialValues={{
          driverName: null,
          vehicleVin: null,
          state: null,
          startDate: null,
          endDate: null,
        }}
        className="CSAForms"
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        handleOnCancel={(fields) => {
          changeRequest();
          setPagination(true);
        }}
        customProps={{
          history,
          callback,
          hasApiStatus,
        }}
      />
    </>
  );
};

ViewForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default ViewForm;
